import { z } from 'zod'

import { RESERVED_SLUGS } from '@/routes/org-routes.const'

const slugField = z
  .string()
  .min(1, 'Organization URL is required')
  .max(48, 'Organization URL must be at most 48 characters')
  .regex(/^[a-z0-9-]+$/, 'URL must contain only lowercase letters, numbers, and hyphens')
  .refine((val) => !RESERVED_SLUGS.has(val), {
    message: 'This URL is reserved and cannot be used',
  })

const nameField = z
  .string()
  .min(1, 'Organization name is required')
  .max(64, 'Organization name must be at most 64 characters')

export const orgProfileFormSchema = z.object({
  name: nameField,
})

export type OrgProfileFormSchemaType = z.infer<typeof orgProfileFormSchema>

export const orgSlugFormSchema = z.object({
  slug: slugField,
})

export type OrgSlugFormSchemaType = z.infer<typeof orgSlugFormSchema>

export const createOrganizationFormSchema = z.object({
  name: nameField,
  slug: slugField,
})

export type CreateOrganizationFormSchemaType = z.infer<typeof createOrganizationFormSchema>
